import { IRewardFilter } from "../../../interfaces/campaign-filter";
import { h } from "preact";
import {
  useRewardActionHandler,
  useSingleRewardFilter,
} from "../../../hooks/reward";
import { CenterLoadingSpinner } from "../../loading-spinner";
import { Info } from "../../info";
import { useRewardFragmentManager } from "../../../hooks/reward-screen-manager";
import { IFragment } from "../../../interfaces/fragment";
import { useActionEmitter } from "../../../hooks/action-emitter";
import DirectRewardRoot1, {
  IDirectRewardRoot1Layouts,
} from "../../routes/direct-root-1";
import SimpleGameRoot1, {
  ISimpleGameRoot1Layouts,
} from "../../routes/simple-game-root-1";
import IntroRoot2, { IIntroRoot2Layouts } from "../../routes/intro-root-2";
import { useExternalActionHandler } from "../../../hooks/external-action-handler";
import { useAnalytics } from "../../../hooks/analytics";
import { useRouterActionHandler } from "../../../hooks/router";
import IntroRoot1, { IIntroRoot1Layouts } from "../../routes/intro-root-1";
import RewardRoot1, { IRewardRoot1Layouts } from "../../routes/reward-root-1";
import { useAssetLoader } from "../../../hooks/asset-loader";
import { ErrorWrapper } from "../error-wrapper";
import { LoadingWrapper } from "../loading-wrapper";
import { ThemeWrapper } from "../../theme-wrapper";

export interface IRewardWrapper {
  type_id: "REWARD_WRAPPER";
  filter: IRewardFilter;
  fragment: {
    rootId: string;
  };
}

export function RewardWrapper({ filter, fragment }: IRewardWrapper) {
  const [reward, rewardLoadStatus] = useSingleRewardFilter(filter);
  const [rootId, root, selectedFragment, onRewardScreenAction] =
    useRewardFragmentManager(reward, fragment);
  const [onAnalyticsAction] = useAnalytics({
    rootTypeId: root?.type_id,
    rootId: rootId,
    pageName: root ? root["pageName"] : null,
    reward,
  });
  const [rewardStatus, onRewardAction] = useRewardActionHandler(onAnalyticsAction);
  const [onExternalAction] = useExternalActionHandler();
  const [onRouterAction] = useRouterActionHandler();
  const [status, emit, onAction] = useActionEmitter(
    [
      onRewardAction,
      onRewardScreenAction,
      onExternalAction,
      onRouterAction,
      onAnalyticsAction,
    ],
    null
  );

  useAssetLoader(selectedFragment);

  if (
    rewardLoadStatus.state === "LOADING" ||
    rewardLoadStatus.state === "IDEL"
  ) {
    return <LoadingWrapper status={rewardLoadStatus} onAction={onAction} />;
  } else if (rewardLoadStatus.state === "LOAD_ERROR") {
    return <ErrorWrapper status={rewardLoadStatus} onAction={onAction} />;
  }

  if(!root) return;

  if (
    root.type_id === "SPIN_THE_WHEEL_ROOT_1" ||
    root.type_id === "SLOT_MACHINE_ROOT_1" ||
    root.type_id === "COIN_TOSS_ROOT_1" ||
    root.type_id === "ROLL_THE_DICE_ROOT_1" ||
    root.type_id === "GIFT_BOX_ROOT_1" ||
    root.type_id === "UNITY_GAME_ROOT_1" ||
    root.type_id === "SCRATCH_CARD_ROOT_1" ||
    root.type_id === "QUIZ_ROOT_1" ||
    root.type_id === "QUIZ_ROOT_2" ||
    root.type_id === "MEMORY_GAME_ROOT_1" ||
    root.type_id === "SURVEY_ROOT_1"
  ) {
    return (
      <ThemeWrapper theme={reward.layout.theme}>
        <SimpleGameRoot1
          {...root}
          screen={selectedFragment as IFragment<ISimpleGameRoot1Layouts>}
          onAction={onAction}
          reward={reward}
        />
      </ThemeWrapper>
    );
  } else if (root.type_id === "DIRECT_REWARD_ROOT_1") {
    return (
      <ThemeWrapper theme={reward.layout.theme}>
        <DirectRewardRoot1
          {...root}
          screen={selectedFragment as IFragment<IDirectRewardRoot1Layouts>}
          onAction={onAction}
          reward={reward}
        />
      </ThemeWrapper>
    );
  } else if (root.type_id === "INTRO_ROOT_2") {
    return (
      <ThemeWrapper theme={reward.layout.theme}>
        <IntroRoot2
          {...root}
          screen={selectedFragment as IFragment<IIntroRoot2Layouts>}
          onAction={onAction}
          reward={reward}
        />
      </ThemeWrapper>
    );
  } else if (root.type_id === "INTRO_ROOT_1") {
    return (
      <ThemeWrapper theme={reward.layout.theme}>
        <IntroRoot1
          {...root}
          screen={selectedFragment as IFragment<IIntroRoot1Layouts>}
          onAction={onAction}
        />
      </ThemeWrapper>
    );
  } else if (root.type_id === "REWARD_ROOT_1") {
    return (
      <ThemeWrapper theme={reward.layout.theme}>
        <RewardRoot1
          {...root}
          screen={selectedFragment as IFragment<IRewardRoot1Layouts>}
          onAction={onAction}
          reward={reward}
        />
      </ThemeWrapper>
    );
  }
}
